import { Sidebar } from './Sidebar';
import { BreadcrumbBar } from './BreadcrumbBar';
import { BreadcrumbLocationSync } from '@/lib/breadcrumbs/BreadcrumbLocationSync';
import { PORTAL_SCROLL_ROOT_ID } from '@/lib/portal-scroll-root';
import { OrganizationAgreementBanner } from '@/components/legal/OrganizationAgreementBanner';
import { UpcomingUserAgreementsBanner } from '@/components/legal/UpcomingUserAgreementsBanner';

export type MainLayoutContentWidth = 'standard' | 'full';

export interface MainLayoutProps {
    children: React.ReactNode;
    contentWidth?: MainLayoutContentWidth;
}

export function MainLayout({ children, contentWidth = 'standard' }: MainLayoutProps) {
    const contentWidthClassName: string = contentWidth === 'full' ? 'max-w-none' : 'max-w-7xl';

    return (
        <div className="flex h-screen bg-gray-50">
            <Sidebar />
            <main
                id={PORTAL_SCROLL_ROOT_ID}
                className="relative flex flex-1 flex-col overflow-y-auto bg-gray-50"
            >
                <BreadcrumbLocationSync />
                <BreadcrumbBar />
                <OrganizationAgreementBanner />
                <UpcomingUserAgreementsBanner />
                <div className={`${contentWidthClassName} mx-auto w-full p-8`}>{children}</div>
            </main>
        </div>
    );
}
